import { showMessages } from "@intercom/messenger-js-sdk";

export function upsellAction() {
    showMessages();
}
